import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { bankInfo, currency, invoiceItem } from '../../utils/constant';
import { useTranslation, Trans } from 'react-i18next';
import useFormValidation from '../../hooks/useFormValidation';
import { accomodationFormValidationSchema } from '../../utils/formValidation';
import { convertToSubcurrency, convertToUTCDateInputFormat, normalizeDate } from '../../utils/utility';
import { errorToast } from '../../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { getAccommodationForm, topUpAndRefund } from '../../services/accomodationApi';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import Checkout from '../../components/Checkout';
import { useNavigate } from 'react-router-dom';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const base_url = process.env.REACT_APP_BASE_URL;
const ids = [
    '0283', '0084', '0625', '0012', '0196', '0191', '0261', '0119', '0757', '0048',
    '0811', '0815', '0264', '0661', '0831', '0158', '0088', '0263', '0211', '0208',
    '0846', '0135', '0818', '0381', '0469', '0614', '0698', '0809', '0373', '0055',
    '0325', '0852', '0326', '0287', '0031', '0416', '0353', '0489', '0639', '0602',
    '0028', '0806', '0339', '0624', '0041', '0347', '0292', '0619', '0162', '0322',
    '0759', '0243', '0197', '0468', '0167', '0509', '0453', '0626', '0137', '0076',
    '0756', '0615', '0140', '0442', '0080', '0176', '0181', '0224', '0242', '0278',
    '0392', '0410', '0420', '0454', '0459', '0701', '0711', '0843', '0003', '0010',
    '0143', '0147', '0207', '0206', '0223', '0235', '0302', '0297', '0301', '0342',
    '0472', '0803', '0805', '0810', '0446', '0839', '0240', '0058', '0073', '0100',
    '0128', '0202', '0622', '0722', '0187', '0604'
]

const ChangeToSingleRoom = () => {
    const { t } = useTranslation();
    const courseData = localStorage.getItem("courseData")
        ? JSON.parse(localStorage.getItem("courseData"))
        : null;
    const currencyCopy = currency(t);
    const bankInfoCopy = bankInfo(t);
    const invoiceItemCopy = invoiceItem(t);
    const [formData, setFormData] = useState("");
    const [roomTypeChoose, setRoomTypeChoose] = useState("");
    const [roomType, setRoomType] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(accomodationFormValidationSchema(t, courseData));
    const [isEligible, setIsEligible] = useState(false);
    const navigate = useNavigate();
    const [paymentMethod, setPaymentMethod] = useState('');
    const [currencySelected, setCurrencySelected] = useState({
        key: "",
        currency: "",
        rate: 1,
    });
    const [checkoutItem, setCheckoutItem] = useState({
        isRefund: 0,
        earlyStayAmount: 0,
        extendStayAmount: 0,
        amountDifference: 0,
        tourismTax: 0,
    });
    const [transactionFee, setTransactionFee] = useState(0);
    const [totalAmount, setTotalAmount] = useState({ totalAmount: 0, totalAmountInCurrencySelected: 0 });
    const [netTotalAmount, setNetTotalAmount] = useState(0);
    const [extendStayDay, setExtendStayDay] = useState(0);
    const [earlyStayDay, setEarlyStayDay] = useState(0);

    const fetchAccommodation = async () => {
        try {
            const data = await getAccommodationForm();
            if (data) {
                if (data.room_type === "singleroom") {
                    toast.error(t("ChangeToSingleRoom.singleRoomAlr"));
                    setTimeout(() => {
                        navigate(`${base_url}/view-accommodation`)
                    }, 1000);
                }
                setRoomType(data.room_type);
                setRoomTypeChoose("singleroom");
                setFormData({
                    is_compliance_health_measure: data.is_compliance_health_measure,
                    check_in_date: convertToUTCDateInputFormat(data.check_in_date),
                    check_out_date: convertToUTCDateInputFormat(data.check_out_date),
                    is_addon_bed: data.is_addon_bed,
                    is_early_check_in: data.is_early_check_in,
                    is_extend_stay: data.is_extend_stay,
                    is_roommate: data.is_roommate,
                    offline_payment_currency: "",
                    offline_payment_prove: "",
                    payment_mode: "",
                    room_type: "singleroom",
                    room_type_assigned: data.room_type_assigned,
                    roommate_id: data.roommate_id,
                    roommate_name: data.roommate_name,
                    roommate_relationship: data.roommate_relationship,
                });
                const desiredStartDate = normalizeDate(data.check_in_date);
                const startDate = normalizeDate('2025-03-26');
                setEarlyStayDay(
                    (startDate - desiredStartDate) / (1000 * 60 * 60 * 24) // Convert milliseconds to days
                );

                const desiredEndDate = normalizeDate(data.check_out_date);
                const endDate = normalizeDate('2025-04-01');
                setExtendStayDay(
                    (desiredEndDate - endDate) / (1000 * 60 * 60 * 24) // Convert milliseconds to days
                );

                const amountDifference = invoiceItemCopy.find(i => i.key === "singleroom").amount - invoiceItemCopy.find(i => i.key === data.room_type).amount;
                setCheckoutItem((prevState) => ({
                    ...prevState,
                    amountDifference: Number(amountDifference),
                    isRefund: Number(amountDifference) < 0 ? "1" : "0"
                }));
            }
        } catch (error) {
            errorToast(error, t("general.Reload"), t);
        }
    };

    useEffect(() => {
        const loginID = JSON.parse(localStorage.getItem("username"));
        if (!ids.includes(loginID) && !loginID.toLowerCase().includes('v')) {
            toast.error(t("ChangeToSingleRoom.notQualified"));
            setTimeout(() => {
                localStorage.clear();
                window.location.reload();
            }, 1000);
        } else {
            setIsEligible(true);
        }
        fetchAccommodation();
    }, []);

    useEffect(() => {
        setCheckoutItem((prevState) => ({
            ...prevState,
            earlyStayAmount: earlyStayDay *
                (invoiceItemCopy.find((item) => item.key === "earlyStaySingleRoom").amount - invoiceItemCopy.find((item) => item.key === "earlyStay").amount),
            extendStayAmount: extendStayDay *
                (invoiceItemCopy.find((item) => item.key === "earlyStaySingleRoom").amount - invoiceItemCopy.find((item) => item.key === "earlyStay").amount),
        }));
    }, [extendStayDay, earlyStayDay])

    useEffect(() => {
        let totalNet = (Number(checkoutItem.earlyStayAmount) +
            Number(checkoutItem.extendStayAmount) +
            Number(checkoutItem.amountDifference)
        ).toFixed(2);
        let totalSum = (Number(totalNet) + Number(transactionFee)).toFixed(2);
        let totalInCurrencySelected = (Number(totalSum) * Number(currencySelected.rate)).toFixed(2);
        setNetTotalAmount(totalNet);
        setTotalAmount({
            totalAmount: totalSum,
            totalAmountInCurrencySelected: totalInCurrencySelected
        });
    }, [checkoutItem, transactionFee, currencySelected]);

    useEffect(() => {
        setTransactionFee(paymentMethod === "creditcard" ? ((0.04 * Number(netTotalAmount) + 1) / 0.96).toFixed(2) : 0);
    }, [totalAmount, paymentMethod]);

    const handleCurrencyChange = (e) => {
        const { id, value } = e.target;
        const currencyInfo = currencyCopy.filter((item) => item.key === value);
        setCurrencySelected({
            key: currencyInfo.length >= 1 ? currencyInfo[0].key : "",
            currency: currencyInfo.length >= 1 ? currencyInfo[0].currency : "",
            rate: currencyInfo.length >= 1 ? currencyInfo[0].rate : 1
        });
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value)
    }

    const [fileError, setFileError] = useState("");
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    const handleFileChange = (event) => {
        const { id } = event.target;
        const selectedFile = event.target.files[0];
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "image/jpg",
            "image/heic"
        ];
        if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
            setFileError(t("FormValid.FileExtensionAllow"));
            event.target.value = ""; // Clear the file input
            return;
        } else if (selectedFile && selectedFile.size > maxSize) {
            setFileError(t("FormValid.smallerFile"));
            event.target.value = ""; // Clear the file input
            return;
        } else {
            setFileError("");
            setFormData((prevState) => ({
                ...prevState,
                [id]: selectedFile,
            }));
            validateField(id, selectedFile);
        }
    };

    const setNullFormToEmpty = (nullFormData) => {
        for (const [key, value] of Object.entries(nullFormData)) {
            if (value === null || value === undefined) {
                nullFormData[key] = ''; // Replace with an empty string
            }
        }
        return nullFormData;
    }
    const generateValidationFields = () => {
        let validationFields = ["is_compliance_health_measure", "room_type", "is_addon_bed", "is_roommate", "check_in_date", "check_out_date"];
        formData.is_roommate === "1" && validationFields.push("roommate_id", "roommate_name", "roommate_relationship");
        if (checkoutItem.isRefund === "0") {
            if (checkoutItem.amountDifference > 0) {
                validationFields.push("payment_mode");
            }
            formData.payment_mode === "offline" &&
                validationFields.push("offline_payment_currency", "offline_payment_prove")
        }
        return validationFields;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        let transformedFormData = setNullFormToEmpty(formData);
        let validationFields = generateValidationFields();
        try {
            if (validateAllFields(transformedFormData, validationFields) && fileError === "") {
                // Step 4: Submit form data
                const combinedFormData = {
                    ...formData,
                    ...checkoutItem,
                    ...totalAmount,
                    transactionFee: transactionFee,
                    netTotalAmount: netTotalAmount,
                    payment_type: "Top-Up"
                };
                const response = await topUpAndRefund(combinedFormData);
                if (response) {
                    toast.success(t("accomodation.RequestDone"));
                    setTimeout(() => {
                        navigate(`${base_url}/view-accommodation`)
                    }, 1000);
                }
            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, name } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: id,
        }));
        setPaymentMethod(id);
        setCurrencySelected({
            key: "",
            currency: "",
            rate: 1
        });
        validateField(name, id);
    };

    return (
        <div className="form-wrapper">
            {formData === "" ?
                <>
                    <div className='info-container mt-5'>
                        <AiOutlineLoading className='spin' />
                        <p>{t("accomodation.Loading_form")}</p>
                    </div>

                </>
                :
                <>
                    {!isEligible ?
                        < div className='info-container mt-5'>
                            <p>{t("ChangeToSingleRoom.notQualified")}</p>
                        </div>
                        :
                        <>
                            <div className='action-buttons d-flex justify-content-center mt-3'>
                                <Button
                                    buttonStyle='btn--primary'
                                    buttonSize='btn--small'
                                    onClick={() => navigate(`${base_url}/view-accommodation`)}
                                >{t("general.BTNcancel")}</Button>
                            </div>
                            <table className="table table-info table-striped mt-3">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">{t("Constant.TwinRoom")}<br />{t("Constant.twinBedSize")}</th>
                                        <th scope="col">{t("Constant.KingRoom")}<br />{t("Constant.kingBedSize")}</th>
                                        <th scope="col">{t("Constant.SingleRoom")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className='th-row' scope="row"><Trans key="accomodation" html="br:<br/>">
                                            {t("accomodation.contentTitle")}
                                        </Trans></th>
                                        <td>{t("accomodation.RM1950")}</td>
                                        <td>{t("accomodation.RM1950")}</td>
                                        <td>{t("accomodation.RM2550")}</td>
                                    </tr>
                                    <tr>
                                        <th className='th-row' scope="row">{t("accomodation.contentTitle2")}</th>
                                        <td>{t("accomodation.RM200")}</td>
                                        <td>{t("accomodation.RM200")}</td>
                                        <td>{t("accomodation.RM200")}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="image-radio-container" style={{ maxWidth: "60%" }}>
                                <div className={`room-radio-option`}
                                >
                                    <span>
                                        <img
                                            src={`${base_url}/images/singleroom.JPG`}
                                            alt="Single Room"
                                        />
                                    </span>
                                    <p>{t("Constant.SingleRoom")} (MYR 2550)</p>
                                </div>
                            </div>
                            <form>
                                <h4 className='mt-4'>{t("accomodation.CheckoutAmount")}</h4>
                                <table className="table table-light table-info">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t("accomodation.AmtTitle")}</th>
                                            <th scope="col">{t("accomodation.AmtItem")}</th>
                                            <th scope="col">{t("accomodation.AMT")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.roomB4")}</th>
                                            <td>{invoiceItemCopy.find(i => i.key === roomType).title}</td>
                                            <td>MYR {invoiceItemCopy.find(i => i.key === roomType).amount}</td>
                                        </tr>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.roomNow")}</th>
                                            <td>{roomTypeChoose ? invoiceItemCopy.find(i => i.key === roomTypeChoose).title : ""}</td>
                                            <td>MYR {roomTypeChoose ? invoiceItemCopy.find(i => i.key === roomTypeChoose).amount : 0}</td>
                                        </tr>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.roomPriceDifferent")}</th>
                                            <td></td>
                                            <td>MYR {checkoutItem.amountDifference}</td>
                                        </tr>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.Early_C_I")}</th>
                                            <td>{earlyStayDay} {t("accomodation.days")}
                                                &nbsp;- {formData.check_in_date}
                                            </td>
                                            <td>MYR {checkoutItem.earlyStayAmount}</td>
                                        </tr>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.Extend_C_O")}</th>
                                            <td>{extendStayDay} {t("accomodation.days")}
                                                &nbsp;- {formData.check_out_date}
                                            </td>
                                            <td>MYR {checkoutItem.extendStayAmount}</td>
                                        </tr>
                                        <tr>
                                            <th className='th-row' scope="row">{t("accomodation.TransactionFees")}</th>
                                            <td>{formData.payment_mode === "creditcard" ? t("accomodation.CreditCard") : t("accomodation.OfflineTransfer")}</td>
                                            <td>MYR {transactionFee}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td className='th-row'><strong>{t("accomodation.TotalRM")} ({t("accomodation.myr")})</strong></td>
                                            <td><strong>{totalAmount.totalAmount}</strong></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td className='th-row'><strong>{t("accomodation.TotalCurrency")} ({currencySelected.key || "MYR"})</strong></td>
                                            <td><strong>{totalAmount.totalAmountInCurrencySelected}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                                {totalAmount.totalAmount > 0 &&
                                    <>
                                        <div className="form-item">
                                            <label>{t("accomodation.PaymentMethod")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className='radio'>
                                                <input className="form-check-input p-2" type="radio" name="payment_mode" id="creditcard" onChange={handleInputChange} required />
                                                <p className='radioLabel mb-0'>{t("accomodation.Method1")}</p>
                                            </div>
                                            <div className='radio'>
                                                <input className="form-check-input p-2" type="radio" name="payment_mode" id="offline" onChange={handleInputChange} required />
                                                <p className='radioLabel mb-0'>{t("accomodation.Method2")}<span style={{ color: "#ff0000" }}>&nbsp;{t("accomodation.Method2Remind")}</span></p>
                                            </div>
                                        </div>
                                        {errors.payment_mode && <span className="error">{errors.payment_mode}</span>}
                                        {paymentMethod === "offline" &&
                                            <>
                                                <div className="form-item">
                                                    <label>{t("accomodation.cURRENCY")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <select className="form-select" onChange={handleCurrencyChange} id="offline_payment_currency" required>
                                                        <option value="">{t("accomodation.ChooseCurrency")}</option>
                                                        {currencyCopy.map((item, index) => (
                                                            <option key={index} value={item.key}>{item.currency}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {errors.offline_payment_currency && <span className="error">{errors.offline_payment_currency}</span>}
                                                {
                                                    currencySelected !== "" &&
                                                    bankInfoCopy
                                                        .filter((i) => i.key === currencySelected.key)
                                                        .map((i, index) => (
                                                            <div className='section-title mb-2 mt-4' key={index}>
                                                                <p>
                                                                    <strong>{i.title}</strong>
                                                                    <br />
                                                                    {i.subtitle}
                                                                    <br />
                                                                    {i.bank && <>{t("accomodation.bank")} {i.bank}<br /></>}
                                                                    {i.image && <><img src={i.image} style={{ "width": "250px" }} alt="" /><br /></>}
                                                                    {i.account && <>{t("accomodation.acc_Num")} {i.account} <br /></>}
                                                                    {i.name && <>{t("accomodation.acc_Name")} {i.name}<br /></>}
                                                                    {i.shiftcode && `SWIFT Code: ${i.shiftcode}`}
                                                                </p>
                                                            </div>
                                                        ))
                                                }
                                                <div className="form-item">
                                                    <label className="form-label">
                                                        {t("accomodation.Upload_Res")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={handleFileChange}
                                                        id="offline_payment_prove"
                                                    />
                                                </div>
                                                <div className="form-info mt-2">
                                                    <p className='mb-0'>{t("general.smallerFile")}</p>
                                                </div>
                                                {fileError && <div className="error mt-2">{fileError}</div>}
                                                {errors.offline_payment_prove && <span className="error">{errors.offline_payment_prove}</span>}
                                            </>
                                        }
                                        {paymentMethod === "creditcard" &&
                                            <Elements
                                                stripe={stripePromise}
                                                options={{
                                                    mode: "payment",
                                                    amount: convertToSubcurrency(((Number(netTotalAmount) + 1) / 0.96).toFixed(2)),
                                                    currency: "myr",
                                                }}
                                            >
                                                <Checkout
                                                    amount={((Number(netTotalAmount) + 1) / 0.96).toFixed(2)}
                                                    formData={setNullFormToEmpty(formData)}
                                                    validateAllFields={validateAllFields}
                                                    checkoutItem={checkoutItem}
                                                    transactionFee={Number(((0.04 * Number(netTotalAmount) + 1) / 0.96))}
                                                    netTotalAmount={Number(netTotalAmount)}
                                                    generateValidationFields={generateValidationFields}
                                                />
                                            </Elements>
                                        }
                                    </>
                                }
                                {
                                    <div className='button-container mt-3'>
                                        <Button buttonStyle="btn--primary" disabled={totalAmount.totalAmount === 0} onClick={handleSubmit} hidden={paymentMethod === "creditcard"} type="button">
                                            {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                                        </Button>
                                    </div>
                                }


                            </form>
                        </>
                    }
                </>
            }

        </div >
    )
}

export default ChangeToSingleRoom